import { DateTime } from "luxon";

export class UploadReq
{
    myToken: string;
    sezione: string; // cassa, contenuti, newsletter
    path: string;
    subfolder: string;
    filename: string;
    base64: string;
    id: string; // serve per calcolare il path
    maxX: number;
    maxY: number;
    quality: number;

    constructor()
    {
        this.myToken = '';
        this.sezione = '';
        this.path = '';
        this.subfolder = '';
        this.filename = '';
        this.base64 = '';
        this.id = '';
        this.maxX = 0;
        this.maxY = 0;
        this.quality = 95;
    }
}

export class UploadResp
{
    error: string;
    path: string;
    filename: string;
    folder: string;
    size: string;

    constructor()
    {
        this.error = '';
        this.path = '';
        this.filename  = '';
        this.folder = '';
        this.size = '';
    }
}

export class WebFile {
    folder: string;
    filename: string;
    size: string;
    length: number;
    date: DateTime | null;
    hasSubfolders: boolean;
    isSelected: boolean;
    createPdfPreview: boolean;

    constructor() {
        this.folder = '';
        this.filename = '';
        this.size = '';
        this.length = 0;
        this.date = null;
        this.hasSubfolders = false;
        this.isSelected = false;
        this.createPdfPreview = false;
    }
}

export class GetFilesReq {
    myToken: string;
    sezione: string;
    folder: string;
    orderby: string;
    search: string;
    extensions: string[];
    pageNum: number;
    pageSize: number;
    subdir: boolean; // ricerca ricorsiva nelle sottocartelle

    constructor() {
        this.myToken = '';
        this.sezione = '';
        this.folder = '';
        this.orderby = '';
        this.search = '';
        this.extensions = [];
        this.pageNum = 1;
        this.pageSize = 50;
        this.subdir = false;
    }
}

export class GetFilesResp {
    // files: string[];
    files: WebFile[]; // webFiles
    folders: WebFile[];
    error: string;
    totFiles: number;
    totPages: number;

    constructor() {
        this.files = [];
        this.folders = [];
        this.error = '';
        this.totFiles = 0;
        this.totPages = 0;
    }
}

export class FileReq {
    myToken: string;
    sezione: string; // media, newsletter
    folder: string;
    filename: string;
    filenameNew: string;

    constructor() {
        this.myToken = '';
        this.sezione = '';
        this.folder = '';
        this.filename = '';
        this.filenameNew = '';
    }
}

export class FileResp {
    error: string;
    base64: string;
    folder: string;
    filename: string;

    constructor() {
        this.error = '';
        this.base64 = '';
        this.folder = '';
        this.filename = '';
    }
}
